import { FC, memo } from 'react';
import { Radio } from 'antd';
import styles from './RadioButton.module.scss';
import { RadioButtonProps } from './RadioButton.types';

const RaidoButton = memo((props: RadioButtonProps) => {
  const { radioGroupData, value, onChange } = props;
  return (
    <span className={styles.fwd_blog_radio_button}>
      <Radio.Group value={value} onChange={onChange} style={{ width: '100%' }}>
        {radioGroupData &&
          radioGroupData?.length > 0 &&
          radioGroupData.map((radioItem: any, index: any) => (
            <Radio.Button
              style={{ width: `calc(50% - 32px))` }}
              value={radioItem.value}
              key={index}
            >
              {radioItem.label}
            </Radio.Button>
          ))}
      </Radio.Group>
    </span>
  );
});
export default RaidoButton;
